import { render, staticRenderFns } from "./ConsultantLegacyImport.vue?vue&type=template&id=a92bb742&scoped=true&"
import script from "./ConsultantLegacyImport.vue?vue&type=script&lang=js&"
export * from "./ConsultantLegacyImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92bb742",
  null
  
)

export default component.exports